import {Component, OnInit} from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

@Component({
    selector: 'app-visionandmission',
    templateUrl: './visionandmission.component.html',
    styleUrls: ['./visionandmission.component.scss']
})
export class VisionandmissionComponent implements OnInit {

    constructor(
        private meta: Meta,
        private titles: Title
    ) {
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);
        this.updateMetaTags();
    }

    updateMetaTags() {
        this.titles.setTitle('Our Vision & Mission: Inspiring Growth and Excellence');
        this.meta.updateTag({
            name: 'description',
            content: `Dive into our Vision & Mission, shaping a future of innovation, excellence, and impactful growth. Guided by purpose, driven by progress.`
        });
    }

}
